import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  articles: [],
  article: {},
};

const getters = {
  getArticles: (state) => state.articles,
  getArticle: (state) => state.article,
  getArticleById: (state) => (id) => state.articles.find((x) => x.id == id),
};

const actions = {
  async fetchArticles({ commit }) {
    try {
      const resp = await api.get("/articles");
      if (resp.status == 200) {
        const articles = resp.data.data;
        console.log("articles:::", articles);
        commit("setArticles", articles);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async fetchOneArticleByCraftsmanId({ commit }, id) {
    try {
      const resp = await api.get(`/articles/one_craftsman/${id}`);
      if (resp.status == 200) {
        const article = resp.data.data;
        commit("setArticle", article);
      }
    } catch (error) {
      return false;
    }
  },

  async fetchOneArticle({ commit }, id) {
    try {
      const resp = await api.get(`/articles/${id}`);
      if (resp.status == 200) {
        const article = resp.data.data;
        commit("setArticle", article);
      }
    } catch (error) {
      return false;
    }
  },
  async updateArticle({ commit }, article) {
    console.log("fsfs", article);
    try {
      const formData = new FormData();
      formData.append("image", article.image);

      formData.append("title", article.title);
      formData.append("writer", article.writer);
      formData.append("txt", article.txt);
      formData.append("keywords", article.keywords);
      formData.append("classes", article.classes);
      formData.append("is_published", article.is_published ? "1" : "0");
      formData.append("craftsman_id", article.craftsman_id);
      formData.append("_method", "patch");
      //const resp = await api.post(`/craftsman_images`, formData);

      //const resp = await api.post(`/articles/${id}`, formData);

      const resp = await api.post(`/articles/${article.id}`, formData);
      if (resp.status == 200) {
        const article = resp.data.data;
        console.log("updated:", article);
        commit("updateArticle", article);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addArticle({ commit }, article) {
    try {
      const formData = new FormData();
      formData.append("image", article.image);

      formData.append("title", article.title);
      formData.append("writer", article.writer);
      formData.append("txt", article.txt);
      formData.append("keywords", article.keywords);
      formData.append("classes", article.classes);
      formData.append("is_published", article.is_published ? "1" : "0");
      formData.append("craftsman_id", article.craftsman_id);
      //const resp = await api.post(`/craftsman_images`, formData);

      const resp = await api.post(`/articles`, formData);

      if (resp.status == 201) {
        const article = resp.data.data;

        commit("addArticle", article);
      }

      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteArticle({ commit }, id) {
    try {
      const resp = await api.delete(`/articles/${id}`);

      if (resp.status == 204) {
        commit("deleteArticle", id);
      }
      console.log("resp", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setArticles(state, articles) {
    state.articles = articles;
  },
  setArticle(state, article) {
    state.article = article;
  },
  updateArticle(state, article) {
    const id = article.id;
    const index = state.articles.findIndex((article) => article.id == id);
    if (index !== -1) {
      state.articles[index] = article;
    }
  },
  addArticle(state, article) {
    state.articles.unshift(article);
  },

  deleteArticle(state, id) {
    const index = state.articles.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.articles.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
